import Modal from "../../shared/Modal";
import { Button } from "../../../ds2/components";
import "./ModalDeleteFileConfirm.css";

type ModalDeleteFileConfirmProps = {
  isOpen: boolean;
  filePath?: string;
  onClose: () => void;
  onContinue: () => void;
};

const ModalDeleteFileConfirm = ({
  isOpen,
  filePath,
  onClose,
  onContinue,
}: ModalDeleteFileConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-delete-file-confirm">
          <div className="modal-delete-file-confirm-title">
            Delete this File
          </div>

          <div className="modal-delete-file-confirm-content">
            This file ({filePath}) will be deleted and cannot be recovered.
          </div>

          <div className="modal-delete-file-confirm-footer">
            <div className="modal-delete-file-confirm-buttons">
              <Button 
                onClick={onClose} 
                variant="secondary"
              >
                Cancel
              </Button>
              <Button
                onClick={() => onContinue()}
                variant="primary"
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalDeleteFileConfirm;
